import { Collapse } from '../../../collapse';
import { Descriptions, type DescriptionsProperties } from '../../../descriptions';
import { Flex } from '../../../flex';
import type { ErrorReport } from '../../types';
import { useGetErrorItems, useGetRequestItems, useGetResponseItems, useGetStackItems } from '../hooks';

type P = {
  environmentItems: DescriptionsProperties['items'];
  report: ErrorReport;
  title?: string;
};

const ErrorReportContent = ({ environmentItems, report, title }: P) => {
  const { errorSummary, request, response } = report;

  const errorItems = useGetErrorItems({ errorSummary });
  const requestItems = useGetRequestItems({ request });
  const responseItems = useGetResponseItems({ response });
  const stackItems = useGetStackItems({ stacks: errorSummary.stacks });

  return (
    <Flex gap="md" vertical>
      <Descriptions
        bordered
        column={1}
        items={[...(environmentItems ?? []), ...errorItems]}
        size="small"
        title={title}
      />
      {request ? (
        <Descriptions bordered column={1} items={requestItems} size="small" title="Request to server" />
      ) : null}
      {response ? (
        <Descriptions bordered column={1} items={responseItems} size="small" title="Server response" />
      ) : null}
      {stackItems.length > 0 ? <Collapse items={stackItems} /> : null}
    </Flex>
  );
};

export default ErrorReportContent;
